export default [
  {
    path: "/tipos-instituicoes",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "tipos_instituicoes_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [
            { label: "Tipos_instituicoes", to: "tipos_instituicoes_list" }
          ],
          permission: "tipo_instituicao:view",
          title: "Tipos_instituicoes"
        }
      },
      {
        name: "tipos_instituicoes_create",
        path: "novo",
        component: () => import("./pages/Create"),
        meta: {
          breadcrumbs: [
            { label: "Tipos_instituicoes", to: "tipos_instituicoes_list" }
          ],
          permission: "tipo_instituicao:create",
          title: "Tipos_instituicoes - Cadastro"
        }
      },
      {
        name: "tipos_instituicoes_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [
            { label: "Tipos_instituicoes", to: "tipos_instituicoes_list" }
          ],
          permission: "tipo_instituicao:edit",
          title: "Tipos_instituicoes - Edição"
        }
      }
    ]
  }
];
